import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

const handlers = new Set();

function onResize() {
    handlers.forEach(fn => fn());
}

export default function useWindowSize(options = {}) {
    const { wait = 100 } = options;
    const isClient = typeof window === 'object';
    const hasDocument = Boolean(document && document.body);
    const [size, setSize] = useState({
        width: isClient ? window.innerWidth : 0,
        height: isClient ? window.innerHeight : 0,
        clientWidth: (hasDocument && document.body.clientWidth) || 0,
        clientHeight: (hasDocument && document.body.clientHeight) || 0,
    });

    const handleResize = throttle(() => {
        setSize({
            width: window.innerWidth,
            height: window.innerHeight,
            clientWidth: (hasDocument && document.body.clientWidth) || 0,
            clientHeight: (hasDocument && document.body.clientHeight) || 0,
        });
    }, wait);

    useEffect(() => {
        if (handlers.size === 0) {
            window.addEventListener('resize', onResize);
        }

        handlers.add(handleResize);

        return () => {
            handlers.delete(handleResize);

            if (handlers.size === 0) {
                window.removeEventListener('resize', onResize);
            }
        };
    }, []);

    return size;
}
